<template>
  <button @click="$emit('btn-click', btn_id)">{{ text }}</button>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: String,
    btn_id: Number,
  },
};
</script>

<style scoped>
button {
  height: 100%;
  width: 100%;
  background-color: #cceeff;
  border: 3px solid #2c3e50;
  border-radius: 8px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #2c3e50;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}
button:hover {
  background-color: #2c3e50;
  color: #cceeff;
}
</style>